// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"21293ceb","29":"b25d96f4","37":"3b0dcd7f","142":"96425a7c","459":"66084cf5","535":"c81b1853","623":"9ed0d6db","732":"19ecee2d","743":"03b4f6eb","916":"bfad54d7","993":"d798bee3"}[chunkId] + ".js";
};